function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var FieldBattleTemplate = require('./field-battle.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var FieldBattleOverlay = /*#__PURE__*/function () {
  function FieldBattleOverlay(app, mod) {
    _classCallCheck(this, FieldBattleOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(FieldBattleOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.pushHudUnderOverlay();
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "renderFortification",
    value: function renderFortification() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.field-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/fortification.png)';
      obj.style.backgroundSize = 'contain';
      this.updateInstructions('Withdraw Units into Fortification?');
    }
  }, {
    key: "renderPostFieldBattle",
    value: function renderPostFieldBattle() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.field-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/field_battle.jpg)';
      obj.style.backgroundSize = 'contain';
      this.updateInstructions('Field Battle over in ' + this.mod.game.spaces[res.spacekey].name);
    }
  }, {
    key: "renderFieldBattle",
    value: function renderFieldBattle() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res);
      var obj = document.querySelector('.field-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/field_battle.jpg)';
      obj.style.backgroundSize = 'contain';
      this.updateInstructions('Field Battle in ' + this.mod.game.spaces[res.spacekey].name);
    }
  }, {
    key: "renderPreFieldBattle",
    value: function renderPreFieldBattle() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.render(res, 1);
      var obj = document.querySelector('.field-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/field_battle.jpg)';
      obj.style.backgroundSize = 'contain';
      this.updateInstructions('Field Battle imminent in ' + this.mod.game.spaces[res.spacekey].name);
    }
  }, {
    key: "assignHits",
    value: function assignHits() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var faction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hits_to_assign = res.attacker_hits;
      if (faction === res.attacker_faction) {
        hits_to_assign = res.defender_hits;
      }
      this.assignHitsManually(res, faction, hits_to_assign);
    }
  }, {
    key: "assignHitsManually",
    value: function assignHitsManually() {
      var _this = this;
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var faction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hits_to_assign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var hits_assignable = 0;
      var hits_assigned = 0;
      var his_self = this.mod;
      this.updateInstructions("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
      this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
      document.querySelectorAll('.not-assignable').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('.hits-assignable').forEach(function (el) {
        try {
          var obj = el.querySelector('.field-battle-unit .field-battle-desc');
          var original_factionspace = obj.innerHTML;
          var factionspace = obj.innerHTML;
          factionspace = factionspace.replace(/<span[^>]*>[^]*?<\/span>/g, '');
          var was_this_guy_besieged = false;
          var can_i_kill_this_guy = false;
          console.log('HERE: ' + was_this_guy_besieged + ' --- ' + factionspace + ' -- ' + original_factionspace);
          if (factionspace !== original_factionspace) {
            was_this_guy_besieged = true;
          }
          console.log('faction: ' + faction);
          if (factionspace === faction || his_self.returnAllyOfMinorPower(factionspace) === faction || his_self.areAllies(factionspace, faction)) {
            can_i_kill_this_guy = true;
          }
          console.log('can i kill this guy? ' + can_i_kill_this_guy);
          if (can_i_kill_this_guy) {
            console.log('yes I can!');
            if (factionspace) {
              obj.innerHTML += ' (click to assign hit)';
            }
            el.classList.add('hits-assignable-hover-effect');
            hits_assignable++;
            console.log('assign hits...');
            el.onclick = function (e) {
              hits_assigned++;
              var hits_left = hits_to_assign - hits_assigned;
              document.querySelectorAll('hits_to_assign').forEach(function (el) {
                el.innerHTML = hits_left;
              });
              var unit_type = el.getAttribute('data-unit-type');
              var faction = el.getAttribute('data-faction');
              var spacekey = res.spacekey;
              el.remove();
              _this.mod.addMove('field_battle_destroy_unit\t' + faction + '\t' + spacekey + '\t' + unit_type);
              if (hits_assigned == hits_to_assign || hits_assigned >= hits_assignable) {
                document.querySelectorAll('.hits-assignable').forEach(function (el) {
                  el.onclick = function (e) {};
                });
                _this.updateInstructions('All Hits Assigned');
                _this.mod.endTurn();
              }
            };
          }
        } catch (err) {
          console.log('ERROR: ' + JSON.stringify(err));
        }
      });
      if (faction != '') {
        if (this.mod.game.player == this.mod.returnPlayerCommandingFaction(faction)) {
          this.mod.hud.updateStatus("Assign <span class=\"hits_to_assign\">".concat(hits_to_assign, "</span> Hits"));
        } else {
          this.updateInstructions(this.mod.returnFactionName(faction) + ' Assigning Hits');
        }
      } else {
        this.updateInstructions('Assigning Hits');
      }
    }
  }, {
    key: "attackersWin",
    value: function attackersWin(res) {
      this.pushHudUnderOverlay();
      this.render(res, 0);
      var obj = document.querySelector('.field-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/field_battle.jpg)';
      obj.style.backgroundSize = 'contain';
      this.updateInstructions('Attackers Win - Close to Continue');
    }
  }, {
    key: "defendersWin",
    value: function defendersWin(res) {
      this.pushHudUnderOverlay();
      this.render(res, 0);
      var obj = document.querySelector('.field-battle-overlay');
      obj.style.backgroundImage = 'url(/his/img/backgrounds/field_battle.jpg)';
      obj.style.backgroundSize = 'contain';
      this.updateInstructions('Defenders Win - Close to Continue');
    }
  }, {
    key: "render",
    value: function render() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pre_battle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var am_i_attacker = false;
      var am_i_defender = false;
      if (this.mod.returnPlayerFactions(this.mod.game.player).includes(res.attacker_faction) || this.mod.returnPlayerCommandingFaction(res.attacker_faction) == this.mod.game.player) {
        am_i_attacker = true;
      }
      if (this.mod.returnPlayerFactions(this.mod.game.player).includes(res.defender_faction) || this.mod.returnPlayerCommandingFaction(res.defender_faction) == this.mod.game.player) {
        am_i_defender = true;
      }
      this.visible = true;
      this.overlay.show(FieldBattleTemplate());
      if (pre_battle == 1) {
        res.attacker_modified_rolls = res.attacker_results;
      }
      if (pre_battle == 1) {
        res.defender_modified_rolls = res.defender_results;
      }
      var space = this.mod.game.spaces[res.spacekey];
      var is_besieged = false;
      if (space.besieged != 0) {
        is_besieged = true;
      }
      if (res.attacker_modified_rolls) {
        for (var i = 0; i < res.attacker_modified_rolls.length; i++) {
          var roll = res.attacker_modified_rolls[i];
          var unit_type = '';
          var faction_name = '';
          var unit_status = '';
          var previously_besieged_unit = 0;
          if (i < res.attacker_units.length) {
            unit_type = res.attacker_units[i];
            faction_name = res.attacker_units_faction[i];
            previously_besieged_unit = res.attacker_units_relief_force[i];
            if (!previously_besieged_unit && is_besieged == true) {
              unit_status = ' (besieged)';
            }
          } else {
            faction_name = 'army leader present';
            unit_type = 'bonus';
          }
          var assignable = '';
          if (am_i_attacker) {
            assignable = ' not-assignable';
          }
          if (['regular', 'mercenary', 'squadron', 'cavalry', 'corsair'].includes(unit_type)) {
            if (am_i_attacker) {
              assignable = ' hits-assignable';
            }
          }
          if (res.attacker_units_destroyed.includes(i)) {
            assignable = 'destroyed';
            faction_name = 'destroyed';
          }
          if (unit_status != '') {
            unit_status = faction_name + '<span>' + unit_status + '</span>';
          } else {
            unit_status = faction_name;
          }
          var rrclass = '';
          if (roll >= 5) {
            rrclass = 'hit';
          }
          if (pre_battle) {
            roll = '?';
            rrclass = '';
          }
          var html = "\n                <div class=\"field-battle-row ".concat(assignable, "\" data-unit-type=\"").concat(unit_type, "\" data-faction=\"").concat(faction_name, "\">\n                \t<div class=\"field-battle-unit\">").concat(unit_type, "<div class=\"field-battle-desc\">").concat(unit_status, "</div></div>\n                \t<div class=\"field-battle-roll ").concat(rrclass, "\">").concat(roll, "</div>\n                </div>\n              ");
          this.app.browser.addElementToSelector(html, '.field-battle-grid .attacker');
        }
      }
      if (res.defender_modified_rolls) {
        for (var _i = 0; _i < res.defender_modified_rolls.length; _i++) {
          var _roll = res.defender_modified_rolls[_i];
          var _unit_type = '';
          var _faction_name = '';
          if (_i < res.defender_units.length) {
            _unit_type = res.defender_units[_i];
            _faction_name = res.defender_units_faction[_i];
          } else {
            _unit_type = 'bonus';
            _faction_name = 'army leader present';
          }
          var _rrclass = '';
          var _assignable = '';
          if (am_i_defender) {
            _assignable = ' not-assignable';
          }
          if (['regular', 'mercenary', 'squadron', 'cavalry', 'corsair'].includes(_unit_type)) {
            if (am_i_defender) {
              _assignable = ' hits-assignable';
            }
          }
          if (res.defender_units_destroyed.includes(_i)) {
            _assignable = 'destroyed';
            _faction_name = 'destroyed';
          }
          if (_roll >= 5) {
            _rrclass = 'hit';
          }
          if (pre_battle) {
            _roll = '?';
            _rrclass = '';
          }
          var _html = "\n                <div class=\"field-battle-row ".concat(_assignable, "\" data-unit-type=\"").concat(_unit_type, "\" data-faction=\"").concat(_faction_name, "\">\n                \t<div class=\"field-battle-unit\">").concat(_unit_type, "<div class=\"field-battle-desc\">").concat(_faction_name, "</div></div>\n                \t<div class=\"field-battle-roll ").concat(_rrclass, "\">").concat(_roll, "</div>\n                </div>\n              ");
          this.app.browser.addElementToSelector(_html, '.field-battle-grid .defender');
        }
      }
      this.attachEvents();
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var help = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var x = document.querySelector('.field-battle-overlay .help');
      if (x) {
        x.innerHTML = help;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "showFieldBattleResults",
    value: function showFieldBattleResults(obj) {}
  }]);
}();
module.exports = FieldBattleOverlay;